import "./Home.css";
import "./HomeMedia.css";
import { Carousel, Form } from "react-bootstrap";
import React, { useRef, useState, useEffect ,useLayoutEffect} from "react";
import FlipBookViewer from "../flipBook/FlipBookViewer";
import flipPageImage from "../../assest/image/Artboard 1 copy 4@4x 1.svg";
import deties1 from "../../assest/image/deities-1.png";
import deties2 from "../../assest/image/deities-2.png";
import { Nav } from "../../component/layout/nav/Nav";
import { Footer } from "../../component/layout/footer/Footer";
import video1 from "../../assest/vedio/whatsapp-video.mp4";
import video2 from "../../assest/vedio/WhatsApp Video 2025-06-07 at 4.36.27 PM.mp4";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { ImageGallerySlider } from "../../component/comman/image-gallery-slider/ImageGallerySlider";
import buttonIcon from "../../assest/image/home-button-icon.svg";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import gsap from "gsap";
import "aos/dist/aos.css";

export const Home = () => {
  const navigate = useNavigate();
  const [showFlipbook, setShowFlipbook] = useState(false);
  const videoSources = [video1, video2];
  const [vebindex, setVebIndex] = useState(0);
  useEffect(() => {
    if (showFlipbook) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [showFlipbook]);

  const videoRefs = useRef([]);

  const [mutedStates, setMutedStates] = useState(videoSources.map(() => true));
  const handleSelect = (selectedIndex, e) => {
    const totalVideos = videoSources.length;

    const newIndex = (selectedIndex + totalVideos) % totalVideos;

    setVebIndex(newIndex);

    videoRefs.current.forEach((v, i) => {
      if (v && i !== newIndex) {
        v.pause();
        v.currentTime = 0;
      }
    });

    const currentVideo = videoRefs.current[newIndex];
    if (currentVideo) {
      currentVideo.play();
    }
  };

  const toggleMute = () => {
    const currentVideo = videoRefs.current[vebindex];
    const newMuted = !mutedStates[vebindex];

    if (currentVideo) {
      currentVideo.muted = newMuted;
    }

    const newStates = [...mutedStates];
    newStates[vebindex] = newMuted;
    setMutedStates(newStates);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: true,
    });
    const interval = setInterval(() => AOS.refresh(), 500);
    return () => clearInterval(interval);
  }, []);
    const heroRef = useRef(null);

useLayoutEffect(() => {
  const ctx = gsap.context(() => {
    const heroEl = document.querySelector(".hero-content");

    if (heroEl) {
      gsap.from(heroEl, {
        x: -150,
        y: 150,
        opacity: 0,
        duration: 2,
        ease: "power4.out",
        delay: 0.2, // slight delay after page load
      });
    }
  }, heroRef);

  return () => ctx.revert();
}, []);

  return (
    <>
    <div ref={heroRef}>
        <div className="Home_Main" >
          <Nav />
          <div className="hero-container">
            <div className="hero-content">
              <p className="hero-subtitle" data-aos="fade-right">
                A Place for Prayer and Peace.
              </p>
              <h1 className="hero-title" data-aos="zoom-in">
                Adhie Annan Temple
              </h1>
              <p className="hero-description" data-aos="fade-left">
                Adhie Anna Temple is one of the oldest and most historic temples
                in Tamil Nadu. It holds great spiritual and cultural
                significance, attracting devotees from all around. With its rich
                history and sacred atmosphere, the temple continues to be a
                place of faith, peace, and devotion.
              </p>
              <button
                className="hero-button"
                onClick={() => setShowFlipbook(true)}
                data-aos="flip-up"
              >
                Explore Temple Story
                <span className="hero-button-icon">
                  <img src={buttonIcon} />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="event-section" data-aos="fade-up">
          <h1 data-aos="zoom-in">
            <span>Event</span> at Adhie Annan Temple
          </h1>

          <div className="event-text" data-aos="fade-left">
            <div
              className={`event-image ${
                !showFlipbook ? "animate-image" : "active"
              }`}
              onClick={() => setShowFlipbook(true)}
            >
              <img src={flipPageImage} alt="Temple Event" />
            </div>

            <div className="event-content">
              <p>
                Greetings, the preparation of the Kumbabhishekam flower should
                be part of the Kumbabhishekam ceremony. The person who prepared
                the flower, those who studied the flower, and those who helped
                with the material for making the flower all benefit from seeing
                the Kumbabhishekam..... <br />
                வணக்கம், கும்பாபிஷேக மலர் தயாரிப்பதும், கும்பாபிஷேகப் பணியில்
                ஒன்றாகவே அமைய வேண்டும். மலரை தயாரித்தவர் மலரைப் படிப்பவர்கள்,
                மலரை தயாரிக்க பொருளுதவி செய்தவர்கள் அனைவருக்கும் கும்பாபிஷேகம்
                தரிசித்த பலனுண்டு
              </p>
              <button onClick={() => setShowFlipbook(true)} data-aos="flip-up">
                learn more
                <span className="hero-button-icon">
                  <img
                    src={buttonIcon}
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                </span>
              </button>
            </div>
          </div>
          {showFlipbook && (
            <FlipBookViewer onClose={() => setShowFlipbook(false)} />
          )}
        </div>
        <div className="about-section-home" data-aos="fade-right">
          <div className="about-content-home">
            <h1 data-aos="fade-right">
              <span>ABOUT</span>
            </h1>
            <h1 data-aos="fade-left">Adhie Annan Temple</h1>
            <p data-aos="fade-up">
              Adhie Annan Temple is one of the most ancient and historical
              temples in Tamil Nadu. Adhie Annan Temple is one of the most
              ancient and historical temples in Tamil Nadu. Adhie Annan Temple
              is one of the most ancient and historical temples in Tamil Nadu.
            </p>
            <button
              className="learn-more-btn"
              onClick={() => navigate("/about")}
              data-aos="flip-up"
            >
              learn more
              <span className="hero-button-icon">
                <img src={buttonIcon} style={{ paddingLeft: "5px" }} />
              </span>
            </button>
          </div>
        </div>
        <div className="deities-section" data-aos="fade-up">
          <div className="deities-left-img" data-aos="fade-right">
            <img src={deties1} alt="Deity Background" />
          </div>

          <div className="deities-right-content">
            <h1>
              <span>deities</span> at adhie annan temple
            </h1>

            <div className="deities-info">
              <div className="deities-img" data-aos="zoom-in">
                <img src={deties2} alt="Deity Image" />
              </div>

              <div className="deities-text">
                <p>
                  Welcome to the divine abode of Adhie Annan Temple, where the
                  presence of sacred deities brings peace, prosperity, and
                  spiritual enlightenment. Each deity in our temple holds deep
                  significance, blessing devotees with divine grace and
                  protection. Feel the divine energy as you participate in daily
                  poojas, aartis, and special rituals. The soothing chants, the
                  glow of sacred lamps, and the essence of devotion create an
                  atmosphere of pure spirituality.
                  <br />
                  புனித தெய்வங்களின் இருப்பு அமைதி, செழிப்பு மற்றும் ஆன்மீக
                  ஞானத்தை அளிக்கும் அதி அன்னான் கோயிலின் தெய்வீக
                  இருப்பிடத்திற்கு வருக. எங்கள் கோயிலில் உள்ள ஒவ்வொரு தெய்வமும்
                  ஆழ்ந்த முக்கியத்துவத்தைக் கொண்டுள்ளது, பக்தர்களுக்கு தெய்வீக
                  அருளையும் பாதுகாப்பையும் வழங்குகிறது. தினசரி பூஜைகள்,
                  ஆரத்திகள் மற்றும் சிறப்பு சடங்குகளில் நீங்கள் பங்கேற்கும்போது
                  தெய்வீக சக்தியை உணருங்கள். இனிமையான மந்திரங்கள், புனித
                  விளக்குகளின் பிரகாசம் மற்றும் பக்தியின் சாராம்சம் தூய
                  ஆன்மீகத்தின் சூழ்நிலையை உருவாக்குகின்றன.
                </p>
                <button onClick={() => navigate("/deities")}>
                  learn more
                  <span className="hero-button-icon">
                    <img
                      src={buttonIcon}
                      style={{ filter: "brightness(0) invert(1)" }}
                      data-aos="flip-up"
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="zoom-in">
          <ImageGallerySlider />
        </div>
        <div className="news-section" data-aos="fade-up">
          <div className="news-header" data-aos="zoom-in">
            <h1>
              <span>News</span> at adhie annan temple
            </h1>
          </div>

          <div className="news-flex">
            <div className="news-carousel-wrapper">
              <Carousel
                fade
                controls
                indicators={false}
                interval={null}
                activeIndex={vebindex}
                onSelect={handleSelect}
                className="custom-carousel"
              >
                {videoSources.map((videoSrc, i) => (
                  <Carousel.Item key={i}>
                    <div className="video-wrapper">
                      <video
                        ref={(el) => (videoRefs.current[i] = el)}
                        className="d-block w-100"
                        src={videoSrc}
                        autoPlay={i === vebindex}
                        loop
                        playsInline
                        muted={mutedStates[i]}
                      />
                    </div>
                  </Carousel.Item>
                ))}
                <div className="video-mute-button">
                  <button onClick={toggleMute}>
                    {mutedStates[vebindex] ? <FaVolumeMute /> : <FaVolumeUp />}
                  </button>
                </div>
              </Carousel>

              <div className="custom-indicators">
                {[0, 1].map((i) => (
                  <span
                    key={i}
                    className={`dot ${vebindex === i ? "active" : ""}`}
                    onClick={() => handleSelect(i)}
                  ></span>
                ))}
              </div>
            </div>

            <div className="news-description">
              <p>
                Stay updated with recent happenings at the temple. From special
                poojas to cultural celebrations, explore the vibrant events that
                bring the community together in devotion and joy.
                <br />
                கோவிலில் நடக்கும் சமீபத்திய நிகழ்வுகள் குறித்து புதுப்பித்த
                நிலையில் இருங்கள். சிறப்பு பூஜைகள் முதல் கலாச்சார கொண்டாட்டங்கள்
                வரை, சமூகத்தை பக்தியிலும் மகிழ்ச்சியிலும் ஒன்றிணைக்கும்
                துடிப்பான நிகழ்வுகளை ஆராயுங்கள்.
              </p>
            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
};
